import React from "react";
import cns from "classnames";

import { Chip } from "@material-ui/core";
import { ChipProps } from "@material-ui/core/Chip";
import Avatar from "./Avatar";
import { ThemeType } from "@theme";
import { makeStyles } from "@material-ui/core/styles";

type Props = {
  className?: string;
  ChipProps?: Partial<ChipProps>;
  size: "normal" | "small";
  name: string;
  src?: string;
  avatarCmp?: React.ReactElement<any>;
  noBg?: boolean;
};

export function AvatarChip(props: Props) {
  const classes = useStyles({});

  const avatar = props.avatarCmp || (
    <Avatar
      size={props.size === "small" ? "mini" : "small"}
      name={props.name}
      src={props.src}
    />
  );

  return (
    <Chip
      className={cns(classes.root, classes[props.size], props.className, {
        [classes.noBg]: props.noBg
      })}
      avatar={avatar}
      label={props.name}
      {...props.ChipProps}
    />
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {},

  micro: {
    height: 16,
    fontSize: 10,

    "& > span": {
      paddingLeft: 8,
      paddingRight: 8
    }
  },

  small: {
    height: 24,
    "& svg": { fontSize: 16 }
  },

  noBg: {
    backgroundColor: "transparent"
  }
}));
